import React from 'react';
import i18next from 'i18next';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { FiPlus, FiMoreHorizontal } from "react-icons/fi";
import moment from 'moment';
import EmployeeGroupEdit from "./EmployeeGroupEditModal";
import GroupEdit from "../Groups/GroupEditModal";
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as employeesActions from 'actions/employeesActions';
import { employeesService } from "services";
import { errorFormating } from "utils/utils";


class EmployeeGroups extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.closeModal = this.closeModal.bind(this);
		this.openNewEmployeeGroupModal = this.openNewEmployeeGroupModal.bind(this);
		this.openEditEmployeeGroupModal = this.openEditEmployeeGroupModal.bind(this);
		this.openEditGroupModal = this.openEditGroupModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getGroups = this.getGroups.bind(this);
	}

	async componentDidMount() {
		await this.getGroups();
		this.openRequestedAssignment();
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.openAssignment && this.props.openAssignment) {
			this.openRequestedAssignment();
		}
	}

	openRequestedAssignment = () => {
		if (!this.props.openAssignment) return;

		this.openNewEmployeeGroupModal();
		if (typeof this.props.onAssignmentRequestHandled === "function") {
			this.props.onAssignmentRequestHandled();
		}
	};

	async getGroups() {
		const employeeId = this.props.employee.id;
		await this.props.getEmployeeGroups(employeeId);
	}

	closeModal() {
		this.props.hideModal()
	}

	openNewEmployeeGroupModal() {
		const { employee } = this.props;

		this.props.showModal({
			open: true,
			title: i18next.t('employeeGroups.assignGroup'),
			style: { width: '350px' },
			content: (
				<EmployeeGroupEdit
					handleClose={this.closeModal}
					employee={employee}
					onDataChanged={this.props.onDataChanged}
				/>
			),
			closeModal: this.closeModal
		}, 'edit')
	}

	openEditEmployeeGroupModal(employee_group) {
		const { employee } = this.props;

		this.props.showModal({
			open: true,
			title: i18next.t('employeeGroups.editAssignment'),
			style: { width: '350px' },
			content: (
				<EmployeeGroupEdit
					employee_group={employee_group}
					employee={employee}
					handleClose={this.closeModal}
					onDataChanged={this.props.onDataChanged}
				/>
			),
			closeModal: this.closeModal
		}, 'edit')
	}

	openEditGroupModal(employee_group) {
		const title = employee_group.group.is_multigroup ? i18next.t("employeeGroups.editMultigroup") : i18next.t("employeeGroups.editGroup");
		this.props.showModal({
			open: true,
			title,
			style: { width: '400px' },
			content: <GroupEdit group={employee_group.group} getGroups={this.getGroups} handleClose={this.closeModal} />,
			closeModal: this.closeModal
		}, 'edit')
	}

	openDeleteEmployeeGroupModal(idGroup) {
		this.props.showModal({
			open: true,
			style: { width: '350px' },
			title: i18next.t('employeeGroups.deleteAssignment'),
			message: i18next.t('employeeGroups.deleteConfirm'),
			deleteAction: () => this.confirmDelete(idGroup),
			closeModal: this.closeModal
		}, 'delete')
	}

	goToPlanning = (employee_group) => {
		const groupId = employee_group.group.id;
		// Calcular fechas: inicio y fin de la semana actual (lunes a domingo)
		const startOfWeek = moment().startOf('isoWeek').format('YYYY-MM-DD'); // Lunes (ISO week)
		const endOfWeek = moment().endOf('isoWeek').format('YYYY-MM-DD'); // Domingo (ISO week)
		// Abrir en nueva ventana la página de planificación con fechas
		window.open(`/plans/${groupId}/${startOfWeek}@${endOfWeek}`, '_blank');
	}

	openAlertModal(message) {
		this.props.showModal({
			open: true,
			title: i18next.t("employeeGroups.errorDeleting"),
			style: { width: '400px' },
			message: message,
			closeModal: this.closeModal
		}, 'alert')
	}

	confirmDelete = async (idGroup) => {
		const response = await employeesService.removeGroup(this.props.employee.id, idGroup);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		}
		else {
			this.getGroups();
			if (typeof this.props.onDataChanged === "function") {
				this.props.onDataChanged();
			}
			this.closeModal();
		}
	}

	getColumns = () => [
		{
			key: "group",
			header: i18next.t('employeeGroups.colGroup'),
			sortAccessor: (row) => row.group?.name || "",
			render: (row) => <button className="btn-transparent btn-editable" onClick={() => this.openEditEmployeeGroupModal(row)}>{row.group.name}</button>,
		},
		{
			key: "start_day",
			header: i18next.t('employeeGroups.colStart'),
			render: (row) => moment(row.start_day).format("DD/MM/YY"),
		},
		{
			key: "end_day",
			header: i18next.t('employeeGroups.colEnd'),
			render: (row) => row.end_day ? moment(row.end_day).format("DD/MM/YY") : "-",
		},
	];

	renderActions = (employee_group) => (
		<Dropdown>
			<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item as="button" onClick={() => this.goToPlanning(employee_group)}>{i18next.t('employeeGroups.goToPlanning')}</Dropdown.Item>
				<Dropdown.Item as="button" onClick={() => this.openEditEmployeeGroupModal(employee_group)}>{i18next.t('employeeGroups.editAssignment')}</Dropdown.Item>
				<Dropdown.Item as="button" onClick={() => this.openEditGroupModal(employee_group)}>{i18next.t('employeeGroups.editGroup')}</Dropdown.Item>
				<Dropdown.Item as="button" onClick={() => this.openDeleteEmployeeGroupModal(employee_group.id)}>{i18next.t('magicPlan.deleteAction')}</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	getContent = () => {
		const { employee_groups } = this.props;
		if (this.props.employee_groups) {
			return (
				<div className="employee-profile-datatable-wrap">
					<DataTable
						tableClassName="table-groups table-employee-groups table-hover"
						columns={this.getColumns()}
						rows={employee_groups}
						rowKey={(row) => row.id}
						emptyMessage={i18next.t('employeeGroups.empty')}
						actionsColumn={{
							render: this.renderActions,
							className: "td-actions",
							header: <button type="button" title="Crear grupo" onClick={this.openNewEmployeeGroupModal} className="btn btn-new"><FiPlus /></button>,
						}}
					/>
				</div>
			);
		}
	}
	render() {
		return (
			<>
				{this.getContent()}
			</>
		)
	}
}


const mapStateToProps = state => {
	return {
		employee_groups: state.employeesReducer.employee_groups,
		user: state.authReducer.user,
	}
}

const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
	getEmployeeGroups: (id) => dispatch(employeesActions.getEmployeeGroups(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeGroups);
